import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1042"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.5 8.678c-.58 0-1.126.369-1.389.94h-.674l-1.432-3.536a.695.695 0 0 0-.674-.438.702.702 0 0 0-.641.485l-1.517 4.694-.834-9.185a.702.702 0 0 0-.593-.631.706.706 0 0 0-.751.428L2.69 9.508H.704c-.387 0-.7.314-.7.702s.313.702.7.702H3.16c.284 0 .54-.172.647-.436l2.398-5.858.886 9.743c.029.331.29.597.62.634a.702.702 0 0 0 .744-.481l1.977-6.12.887 2.19a.7.7 0 0 0 .648.438h1.29c.053.072.512.67 1.244.664.747-.006 1.5-.637 1.5-1.504-.001-.853-.73-1.504-1.501-1.504z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }